import { useEffect, useRef } from 'react';

function useDidUpdateEffect(fn, inputs) {
  const isMountingRef = useRef(false);
  const prevInputs = useRef(inputs);

  useEffect(() => {
    isMountingRef.current = true;
  }, []);

  useEffect(() => {
    if (!isMountingRef.current) {
      const clearEffectFn = fn(prevInputs.current);
      prevInputs.current = inputs;
      return clearEffectFn;
    }
    isMountingRef.current = false;
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, inputs);
}

export default useDidUpdateEffect;
